import LazyLoader from "../loader/LazyLoader";

export function PageSkeleton() {
  return <LazyLoader />;
}

export function ProfileSkeleton() {
  return <LazyLoader />;
}
